<div class="egl-icon__container" [ngClass]="withCircle ? 'egl-icon__container--with-circle' : ''" *ngIf="path">
    <svg-icon
        src="{{ path }}"
        [svgStyle]="{ 'width.px': width, 'height.px': height }"
        [class]="'egl-icon'"
        [ngClass]="iconColor"
    ></svg-icon>
</div>
